import React from "react";
import { sharedErrorBoundaryMessages } from "../shared/errorBoundaryMessages";

export const errorBoundaryMessages = {
    ...sharedErrorBoundaryMessages,
    description: (
        <>
            Please refresh the page to continue ordering.
            <br />
            If you continue to see this page, try again later.
        </>
    ),
    action: "Refresh page",
};
